export const generateInvoiceRef = (date: Date, seqNum: number, baseRefFormat: string) => {
  let refString = baseRefFormat;

  // Replace "AA" or "AAAA" with year substring
  const yearSubstringLength = refString.match(/AA([$^A]|$)|AAAA/)?.[0]?.length === 3 ? 4 : 2;

  const yearSubstring = date.getFullYear().toString().substr(-yearSubstringLength);
  refString = refString.replace("AAAA", yearSubstring);
  refString = refString.replace("AA", yearSubstring);

  // Replace "MM" with month substring
  const monthSubstring = (date.getMonth() + 1).toString().padStart(2, "0");
  refString = refString.replace("MM", monthSubstring);

  // Replace all "XX" with sequential number substring
  const seqNumPaddingLength = refString.match(/X+/)?.[0]?.length;
  const seqNumSubstring = seqNum.toString().padStart(seqNumPaddingLength ?? 0, "0");
  refString = refString.replace(/X+/g, seqNumSubstring);

  return refString;
};
